export { DigViewerCarouselComponent } from "./carousel.component";
